import React, { useContext } from "react";
import style from "./index.module.scss";
import { CourseParams, homeworkDetailUrl } from "../../../API/urls";
import { RouteComponentProps, useHistory } from "react-router-dom";
import useRequest from "../../../Utils/useRequest";
import { getWeekTimePaper } from "../../../API/homework";
import { CourseContext } from "../Store";
import { Spin } from "antd";
import ItemStatus from "./components/ItemStatus";
import ItemLink from "./components/ItemLink";
import CustomEmpty from "../../../components/CustomEmpty";
import moment from "moment";

export default function Homework({ match }: RouteComponentProps<CourseParams>) {
    const history = useHistory();
    const { course } = useContext(CourseContext);
    const courseParams = match.params;
    const [data, { loading }] = useRequest(() =>
        getWeekTimePaper(course.weekTimeId, courseParams)
    );

    function gotoHomework() {
        if (!data) return;
        const homeworkStatus = data.homeWordStatus;
        const paperId = data.paperId;
        const weekTimeId = course.weekTimeId;
        const url = homeworkDetailUrl({
            ...courseParams,
            homeworkStatus,
            paperId,
            weekTimeId
        });
        history.push(url);
    }

    return (
        <div className={style.root}>
            <Spin spinning={loading}>
                <div className={style.count}>共 {!data ? 0 : 1} 项作业任务</div>

                {!data && <CustomEmpty style={{ padding: "100px 0" }} />}

                {data && (
                    <div className={style.item}>
                        <div className={style.main}>
                            <h1 className={style.title}>
                                {data.paperName}{" "}
                                <ItemStatus status={data.homeWordStatus} />
                            </h1>
                            <div className={style.info}>
                                截止时间{" "}
                                {moment(data.endTime).format(
                                    "YYYY/MM/DD HH:mm:ss"
                                )}
                            </div>
                        </div>

                        <div className={style.buttons}>
                            <ItemLink
                                className={style.button}
                                onClick={gotoHomework}
                                status={data.homeWordStatus}
                            />
                        </div>
                    </div>
                )}
            </Spin>
        </div>
    );
}
